module.exports = __webpack_public_path__ + "media/eline.0a835e22.mp4";